// removed by extract-text-webpack-plugin
module.exports = {"container":"_1rQzr0T","flag":"EjR5TbT","text":"_3dXU2qH","redirectLink":"sE0SDig","changeButton":"_3qeH1gO"};


//////////////////
// WEBPACK FOOTER
// ./template/components/WelcomeMat/Message/Message.css
// module id = ./template/components/WelcomeMat/Message/Message.css
// module chunks = client.sitechrome